import {forwardRef} from "react";

type BasicContentType = {
    extraClass?: string;
    children?: any;
}

const BasicContent = forwardRef((props: BasicContentType, ref: any) => {
    return (
        <div className={`inner-content ${props.extraClass ? props.extraClass : ''} `} ref={ref}>
            <div className='container'>
                {props.children}
            </div>
        </div>
    )
})

export default BasicContent